import { config } from '@config/config';
export const getHlsVideoLink = (url, test) =>
  `${config.imgApiUrl}/${test ? 'test-' : ''}stream-videos/${url}/master.m3u8`;


  export const VIDEO_PLAYER_LINK = 'https://kinescope.io/embed/'

export const getVideoLink = (videoId, watermark='') => `${VIDEO_PLAYER_LINK}${videoId}?watermark=${watermark}`